module.exports = __webpack_public_path__ + "static/mailBtn-13909e91329d41d6e5b8ed6b743c73a7.png";